import { Bot, Brain, MessageSquare, Zap } from "lucide-react";

export const CapabilitiesSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-blue-950 to-blue-900">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-white mb-4">
            Capabilities That Drive Results
          </h2>
          <p className="text-xl text-blue-200 max-w-2xl mx-auto">
            Our AI agents and chatbots come equipped with powerful features designed 
            to transform your business operations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              icon: <Brain className="h-12 w-12" />,
              title: "Natural Language Processing",
              description: "Understanding context and nuance in conversations"
            },
            {
              icon: <Bot className="h-12 w-12" />,
              title: "Task Automation",
              description: "Handling repetitive tasks with precision"
            },
            {
              icon: <MessageSquare className="h-12 w-12" />,
              title: "Multi-Channel Support",
              description: "Seamless integration across platforms"
            },
            {
              icon: <Zap className="h-12 w-12" />,
              title: "Real-Time Analytics",
              description: "Insights and performance tracking"
            }
          ].map((capability, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-blue-900/50 border border-blue-700/50 text-center group hover:bg-blue-800/50 transition-colors"
            >
              <div className="inline-block p-3 rounded-full bg-blue-800/50 text-blue-300 group-hover:text-blue-200 transition-colors mb-4">
                {capability.icon}
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">
                {capability.title}
              </h3>
              <p className="text-blue-200">
                {capability.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};